import Gobalstore from "../index";
export const actions = {
  getReport: function (localStore) {
    this.axios({
      method: "GET",
      url: `/business/guarded/reporting/ent-stages`,
    }).then(function (response) {
      localStore.commit("setReporting", response.data);
    });
  },

  sendEmail: function (localStore, payload) {
    return new Promise((resolve, reject) => {
      Gobalstore.commit("LoadingOverlay", true);
      this.axios({
        method: "POST",
        url: `/portal/send-mail`,
        data: payload.body,
        headers: payload.headers
      })
        .then(function (res) {
          resolve(res);
          Gobalstore.commit("LoadingOverlay", false);
        })
        .catch((err) => {
          reject(err);
          Gobalstore.commit("LoadingOverlay", false);
        });
    });
  },
};
